import Axios from 'axios';
import { checkAccessToken } from './auth';

const api = Axios.create({
  baseURL: process.env.REACT_APP_BASE_URL2,
});

api.interceptors.request.use(async (req) => {
  req.params = {
    ...(req.params || {}),
  };
  const token = await checkAccessToken();
  if (token !== null) {
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  }
  throw new Axios.Cancel('Operação cancelada');
}, (err) => Promise.reject(err));

export default api;
